import { sanitizeJsonLdStrings } from "~/utils/jsonld-sanitize";

export const getArticleSchemaScript = ({
  headline,
  description,
  image,
  datePublished,
  dateModified,
  author,
  publisher,
  url,
  keywords,
}) => {
  // Normalise image input and remove empty values.
  const images = Array.isArray(image)
    ? image.filter(Boolean)
    : image
    ? [image]
    : undefined;

  const schema = {
    "@context": "https://schema.org",
    "@type": "Article",
    headline,
    description,
    // Only include image when at least one valid image exists.
    image: images?.length ? images : undefined,
    datePublished,
    dateModified,
    author,
    publisher,
    ...(keywords && { keywords }),
    ...(url && {
      mainEntityOfPage: {
        "@type": "WebPage",
        "@id": url,
      },
    }),
  };

  // Remove null, undefined and empty string values before serialising.
  Object.keys(schema).forEach(key => {
    if (
      schema[key] == null ||
      (typeof schema[key] === "string" && !schema[key].trim())
    ) {
      delete schema[key];
    }
  });

  return [
    {
      hid: "article-schema",
      type: "application/ld+json",
      innerHTML: JSON.stringify(sanitizeJsonLdStrings(schema)),
    },
  ];
};
